import { TimeGrid } from "./TimeGrid";
import {IPeriod, OutagePeriod, Period } from "./Period"
import { IJob, Job, StatusZlecenia } from "./Job"
import { IItem, ContainerType } from "./Container";
import { IResource, Resource } from "./Resource";
import { IResourceDef, ResourceDefs } from "./ResourceDefs";


import Bus from "@/lib/Bus";
import { isObjectBindingPattern } from "typescript";
const bus: Bus = new Bus().getBus(); 



enum TypPracy {
  DRUK = "Druk",
  PRZEWIJANIE = "Przewijanie",
  PAKOWANIE = "Pakowanie",
}


  function random_duration(i: number) {
    return i*10+50;
    //return Math.floor(Math.random() * 100) + 20
  }

  

  export class PlanSvc {
    
    resources:IResource[] = []
    jobs:IJob[] = []
    _id:number = 1000;

    minutesPerDay = 60*24;
    plannigPeriod: IPeriod

    get_id() {
      this._id++
      return this._id.toString()
    }

    
    constructor(days: number) {
      this.plannigPeriod = new Period(new Date('2023-11-05T07:45:00'),days*this.minutesPerDay)
     
    }


  recalc(resource:IResource) {
    const basic_outages = TimeGrid.create_outages(this.plannigPeriod)
    resource.recalc(this.plannigPeriod, basic_outages)
    
  }

  move_job_here(sourceResource: IResource|undefined, sourceJob:IJob|undefined, targetResource:IResource|undefined, targetJob: IJob|undefined):any {

    if (!sourceResource) return;
    if (!sourceJob) return;
    if (!targetResource) return;
    // if (!targetJob) return; null if move at the end

    const sourceIndex:number|undefined = sourceResource.job_index(sourceJob)
    if (sourceIndex===undefined) return
    sourceResource.jobs.splice(sourceIndex, 1); // Remove from original position


    if (targetResource.jobs.length>0 && targetJob) {


        const targetIndex:number|undefined = targetResource.job_index(targetJob)
        if (targetIndex===undefined) return

        const job_before=targetResource.jobs[targetIndex-1]
        const job_after=targetResource.jobs[targetIndex]
        if (job_before) {
          sourceJob.startTime = Period.add_minutes(job_before.endTime,1);
          targetResource.jobs.splice(targetIndex, 0, sourceJob); // Insert at target position
        }
        else {
          console.log("no job before. setting current time", this.plannigPeriod.startTime)
          sourceJob.startTime = Period.add_minutes(job_after.startTime,-1);
          targetResource.jobs.unshift(sourceJob)
        }
        
        
        for (let i=targetIndex+1;i<targetResource.jobs.length; i++) {
          const before = Period.format_hour(targetResource.jobs[i].startTime)
          targetResource.jobs[i].startTime = Period.add_minutes(targetResource.jobs[i].startTime, sourceJob.duration);
          const after = Period.format_hour(targetResource.jobs[i].startTime)
          console.log(i, before, '=>', after)
        }
    } else {
      sourceJob.startTime=this.plannigPeriod.startTime
      targetResource.jobs.push(sourceJob)  
    }

    this.recalc(sourceResource)
    this.recalc(targetResource)
    targetResource.log_jobs(sourceJob)
  }


  async get_plan_from_db(resourceDef: IResourceDef):Promise<any[]> {
    const list:any[] = await bus.api("/api/label/get_plan",{ resourceDef: resourceDef })
    if (!list) return []
    return list;
  }

  async refresh(rd: IResourceDef) {

    
      const machineResource = new Resource([],ContainerType.Maszyna)
      machineResource.id = rd.name
      machineResource.name = rd.name

      if (machineResource) {
      this.resources.push(machineResource)

      const firstStartTime=this.plannigPeriod.startTime; 
      let start_time = firstStartTime

      const zlecenia = await this.get_plan_from_db(rd);

      for (let i=0; i<zlecenia.length; i++) {
        const name:string =  rd.name
        const job = new Job([machineResource], zlecenia[i].OrderStatus, start_time, random_duration(i))
        job.name = zlecenia[i].podzl_idm
        

        machineResource.jobs.push(job)
       
        job.id = this.get_id()
        this.jobs.push(job)

        start_time=Period.add_minutes(start_time,job.duration+1);
      }
      this.recalc(machineResource)
      }
      return machineResource;

}


}
  
  

  

